import { SxProps, TextField, Theme } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers/DatePicker';
import { parseISO, format } from 'date-fns';

interface IDatePicker {
  value: string;
  onChange: (newValue: Date | null) => void;
  disabled?: boolean;
  applyExcludeStyle?: boolean;
}

const DatePicker = ({ value, onChange, disabled, applyExcludeStyle }: IDatePicker) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <MUIDatePicker
        enableAccessibleFieldDOMStructure={false}
        format="yyyy-MM-dd"
        value={parseISO(value)}
        onChange={(newValue) => {
          if (!newValue) return;
          const formattedDate = format(newValue, 'yyyy-MM-dd'); // Keeps it in local timezone
          onChange(new Date(formattedDate)); // Ensure onChange receives a valid Date object
        }}
        sx={{ outline: 'none', border: 'none' }}
        disabled={disabled}
        slots={{
          textField: (params) => (
            <TextField
              {...params}
              InputProps={{
                ...params.InputProps,
                style: {
                  ...params.InputProps?.style,
                  height: '1.5rem', // Set a fixed height to match ListItem
                  fontSize: '0.8rem', // Adjust font size if needed
                  outline: 'none',
                  border: 'none',
                  color: applyExcludeStyle ? '#ffb74d' : 'inherit',
                },
              }}
              className="customDatePickerHeight"
              sx={{
                ...(applyExcludeStyle ? { color: 'orange', textDecoration: 'line-through' } : {}),
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none', // Remove border from the notched outline
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  border: 'none', // Ensure no border on hover
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: 'none', // Ensure no border when focused
                },
              }}
            />
          ),
        }}
      />
    </LocalizationProvider>
  );
};

export default DatePicker;
